import { render, staticRenderFns } from "./productionDetails.vue?vue&type=template&id=5403e37b"
import script from "./productionDetails.vue?vue&type=script&lang=js"
export * from "./productionDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports